import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { IoMail } from "react-icons/io5";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              😎 Programming became my passion, and though I've made progress,
              there's still much to learn... 🤷‍♂️
              <br />
              <br />
              I'm fluent in
              <i>
                <b className="purple"> Python </b>
              </i>
              with advanced skills in
              <i>
                <b className="purple"> TensorFlow and Hugging Face </b>
              </i>{" "}
              Transformers for model development. 🚀
              <br />
              <br />
              I'm interested in playing games with &nbsp;
              <i>
                <b className="purple">Deep Reinforcement Learning </b>
              </i>
              Agents and creating new stuff using&nbsp;
              <i>
                <b className="purple">GANs</b>
              </i>{" "}
              .🤖
              <br />
              <br />
              Me proficient in cloud technologies including
              <i>
                <b className="purple"> Amazon Web Services</b>
              </i>
              ,
              <i>
                <b className="purple"> Google Colab</b>
              </i>
              🌐, and
              <i>
                <b className="purple"> Amazon SageMaker</b>
              </i>
              &nbsp; for model training.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/SirajuddinShaik"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:shaiksirajuddin9949@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <IoMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/shaik-sirajuddin-144484243/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
